export const FETCH_REGULATION_LGPD = 'RegulationLGPD/FETCH'
export const FETCH_REGULATION_LGPD_SUCCESS = `${FETCH_REGULATION_LGPD}_SUCCESS`
export const FETCH_REGULATION_LGPD_FAIL = `${FETCH_REGULATION_LGPD}_FAIL`

const initialState = { isLoading: true, regulations: [] }

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REGULATION_LGPD:
      return { ...state, isLoading: true }
    case FETCH_REGULATION_LGPD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        regulations: action.payload.data
      }
    case FETCH_REGULATION_LGPD_FAIL:
      return { ...state, isLoading: false }
    default:
      return { ...state }
  }
}

export const fetchRegulationsLGPD = () => ({
  type: FETCH_REGULATION_LGPD,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'GET',
      url: `/v1/participants/regulations/pending`
    }
  }
})



// WEBPACK FOOTER //
// ./src/features/RegulationModal/ducks.js